// Angular imports
import { Injectable } from '@angular/core';

// RxJs imports
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BoardApprovalHelperService {
    // As per Sandeep's discussion on 2024-11-08, loading panel message has custom text for Portfolio mode
    private readonly _subjectLoading = new Subject<{ message: string; showLoading: boolean }>();

    onLoadingEvent(): Subject<{ message: string; showLoading: boolean }> {
        return this._subjectLoading;
    }

    showLoading(loadingMessage: string = 'Loading...'): void {
        this._subjectLoading.next({ message: loadingMessage, showLoading: true });
    }

    hideLoading(): void {
        this._subjectLoading.next({ message: null, showLoading: false });
    }
}
